var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_getPrototype.js
// module id = 607
// module chunks = 0 1 2 3 4 5 6 7 8